/*set components*/
import Home  from './Home';
import Evento  from './Evento';

/*set icons*/
import Face3Icon from '@mui/icons-material/Face3';


export const routes_modules = [
  {
    name: "Eventos",
    path: "/",
    component: Home,
    menu: true,
    private: false,
    icon: <Face3Icon />,
    title: "Eventos",
    subtitle: "Desarrollos inmobiliarios"
  },
  {
    name: "Evento",
    path: "/*",
    component: Evento,
    menu: true,
    private: false,
    icon: <Face3Icon />,
    title: "Eventos",
    subtitle: "Desarrollos inmobiliarios"
  },
];
